import { ContentTagEffects } from '../../../../features/cms-content-tag-base/store/effects/content-tag.effect';
import { ComponentsEffects } from './components.effect';
import { NavigationEntryItemEffects } from './navigation-entry-item.effect';
import { PageEffects } from './page.effect';
export const effects: any[] = [PageEffects, ComponentsEffects, NavigationEntryItemEffects, ContentTagEffects];
export * from '../../../../features/cms-content-tag-base/store/effects/content-tag.effect';
export * from './components.effect';
export * from './navigation-entry-item.effect';
export * from './page.effect';
